// extracted by mini-css-extract-plugin
module.exports = {"whiteBox":"ServiceCard_whiteBox__Kn_os","content":"ServiceCard_content__MYcP2","button":"ServiceCard_button__h15q0"};